import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { FlatButton, SelectField, MenuItem } from 'material-ui';
import { withTemplates } from 'dash-front/campaign/enhancers';
import { fetchTemplates } from 'dash-front/actions';

function TemplateChangerButtonsComponent({ templates = [], template, onTemplateChanged = () => {} }) {
    return (
        <div>
            <h1>Template {template}</h1>
            {templates
                .filter(t => !t.isHidden)
                .map(t => (
                    <FlatButton
                        primary={t.id === template}
                        key={t.id}
                        label={t.name}
                        onClick={() => onTemplateChanged(t.id)}
                    />
                ))}
        </div>
    );
}

function TemplatePicker({ templates = [], template, onTemplateChanged = () => {} }) {
    return (
        <SelectField
            floatingLabelText="Template"
            value={template}
            onChange={(event, index, value) => {
                onTemplateChanged(value);
            }}
        >
            {templates
                .filter(t => !t.isHidden)
                .map(t => (
                    <MenuItem key={t.id} value={t.id} primaryText={t.name} />
                ))}
        </SelectField>
    );
}

const withFetchTemplates = CMP =>
    compose(
        withTemplates,
        connect(
            () => ({}),
            {
                fetchTemplates,
            },
        ),
        lifecycle({
            componentWillReceiveProps() {},
            componentDidMount() {
                this.props.fetchTemplates();
            },
        }),
    )(({ fetchTemplates, dispatch, ...props }) => <CMP {...props} />);

const TemplateChangerButtons = withFetchTemplates(TemplateChangerButtonsComponent);
export { TemplatePicker, TemplateChangerButtons, withFetchTemplates };

export default withFetchTemplates(TemplatePicker);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/TemplateChanger.js
 **/